module.exports = __webpack_public_path__ + "img/A户型.d0574ae2.png";